import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'contactUsLink',
  initialState: null as string | null,
  reducers: {
    setContactUsLink(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setContactUsLink } = slice.actions;
export default slice.reducer;